import { ProjectDetailState } from '../state';
import { DelegateMapEntry } from 'containers/Base/ActionDelegate';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'store/reducer';
import { AppConfig } from '../../../../data/terra/AppConfig';

export const SELECT_APP_CONFIG = 'project/appConfigs/select';

export interface SelectAppConfigAction {
  type: typeof SELECT_APP_CONFIG;
  appConfig: AppConfig;
}

export const selectAppConfig = (
  appConfig: AppConfig
): ThunkAction<void, RootState, unknown, Action<string>> => async dispatch => {
  dispatch({
    type: SELECT_APP_CONFIG,
    appConfig,
  } as SelectAppConfigAction);
};

export const selectAppConfigDelegate: DelegateMapEntry<
  SelectAppConfigAction,
  ProjectDetailState
> = {
  [SELECT_APP_CONFIG]: (
    state: ProjectDetailState,
    action: SelectAppConfigAction
  ): ProjectDetailState => {
    return {
      ...state,
      selectedAppConfig: action.appConfig,
    };
  },
};
